import styled from 'styled-components';
import { Box } from '@bechtel/gds';

export const RodRequestDetailStyled = styled(Box)`
  overflow-y: hidden;
  height: 100vh;
`;
